<template>
  <table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;" :style="{ 'font-family': data.font }">
    <tbody>
      <tr>
        <td align="left" style="padding:0;">
          <div v-if="data.imageUrl" style="text-align:left;">
            <img
              :src="data.imageUrl"
              alt=""
              :style="data._placeholderFields?.has?.('imageUrl')
                ? {
                    width: '170px',
                    height: '42px',
                    borderRadius: '8px',
                    aspectRatio: '85 / 21',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    objectFit: 'contain',
                    display: 'block'
                  }
                : {
                    display: 'block',
                    maxWidth: '170px',
                    maxHeight: '85px',
                    borderRadius: '8px',
                    width: 'auto',
                    height: 'auto'
                  }"
            />
            <div
              style="
                width: 100%;
                margin-top: 12px;
                margin-bottom: 12px;
                border-top: 1px solid #E8E6E3;
              "
            ></div>
          </div>
        </td>
      </tr>

      <tr>
        <td>
          <div
            v-if="data.displayName"
            style="
              font-style: normal;
              font-weight: 500;
              line-height: 1.2;
              margin-bottom: 8px;
            "
            :style="{ fontSize: useFontSizeScale(20).value }"
          >
            <span>{{ data.displayName }}</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div
            style="font-style: normal; font-weight: 500; line-height: 1.2;"
            :style="{ fontSize: useFontSizeScale(12).value }"
          >
            <div style="margin-bottom: 8px;">
              <a
                v-if="data.website"
                target="_blank"
                :href="data.website.startsWith('http') ? data.website : 'https://' + data.website"
                style="color: inherit; text-decoration: none;"
              >
                {{ data.website }}
              </a>
            </div>

            <div v-if="data.telephoneNumber" style="margin-bottom: 8px;">
              <a v-if="data.telephoneNumber" :href="'tel:' + data.telephoneNumber" style="color: inherit; text-decoration: none;">
                {{ data.telephoneNumber }}
              </a>
            </div>

            <!-- Social Icons -->
            <table
              v-if="data.chat || data.instagram || data.facebook || data.linkedin || data.youtube || data.x"
              role="presentation"
              cellspacing="0"
              cellpadding="0"
              border="0"
              style="border-collapse:collapse;"
            >
              <tbody>
                <tr>
                  <td v-if="data.chat && data.chatIconUrl" style="padding-right:12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                        <tr>
                          <td width="16" height="16" style="width:16px; height:16px; line-height:0; mso-line-height-rule:exactly;">
                            <a
                              :href="data.chat"
                              target="_blank"
                              style="display:block; text-decoration:none; line-height:0;"
                            >
                              <img
                                :src="data.chatIconUrl"
                                alt="Chat"
                                style="display:block; width:16px; height:16px; border:0; outline:none;"
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td v-if="data.instagram && data.instagramIconUrl" style="padding-right:12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                        <tr>
                          <td width="16" height="16" style="width:16px; height:16px; line-height:0; mso-line-height-rule:exactly;">
                            <a
                              :href="'https://www.instagram.com/' + data.instagram"
                              target="_blank"
                              style="display:block; text-decoration:none; line-height:0;"
                            >
                              <img
                                :src="data.instagramIconUrl"
                                alt="Instagram"
                                style="display:block; width:16px; height:16px; border:0; outline:none;"
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td v-if="data.facebook && data.facebookIconUrl" style="padding-right:12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                        <tr>
                          <td width="16" height="16" style="width:16px; height:16px; line-height:0; mso-line-height-rule:exactly;">
                            <a
                              :href="'https://www.facebook.com/' + data.facebook"
                              target="_blank"
                              style="display:block; text-decoration:none; line-height:0;"
                            >
                              <img
                                :src="data.facebookIconUrl"
                                alt="Facebook"
                                style="display:block; width:16px; height:16px; border:0; outline:none;"
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td v-if="data.linkedin && data.linkedinIconUrl" style="padding-right:12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                        <tr>
                          <td width="16" height="16" style="width:16px; height:16px; line-height:0; mso-line-height-rule:exactly;">
                            <a
                              :href="'https://www.linkedin.com/in/' + data.linkedin"
                              target="_blank"
                              style="display:block; text-decoration:none; line-height:0;"
                            >
                              <img
                                :src="data.linkedinIconUrl"
                                alt="LinkedIn"
                                style="display:block; width:16px; height:16px; border:0; outline:none;"
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td v-if="data.youtube && data.youtubeIconUrl" style="padding-right:12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                        <tr>
                          <td width="16" height="16" style="width:16px; height:16px; line-height:0; mso-line-height-rule:exactly;">
                            <a
                              :href="'https://www.youtube.com/@' + data.youtube"
                              target="_blank"
                              style="display:block; text-decoration:none; line-height:0;"
                            >
                              <img
                                :src="data.youtubeIconUrl"
                                alt="YouTube"
                                style="display:block; width:16px; height:16px; border:0; outline:none;"
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td v-if="data.x && data.xIconUrl" style="padding-right:12px;">
                    <table role="presentation" cellspacing="0" cellpadding="0" border="0">
                      <tbody>
                        <tr>
                          <td width="16" height="16" style="width:16px; height:16px; line-height:0; mso-line-height-rule:exactly;">
                            <a
                              :href="'https://www.x.com/' + data.x"
                              target="_blank"
                              style="display:block; text-decoration:none; line-height:0;"
                            >
                              <img
                                :src="data.xIconUrl"
                                alt="X (Twitter)"
                                style="display:block; width:16px; height:16px; border:0; outline:none;"
                              />
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup>
import { useFontSizeScale } from '@/io.ox/mail/settings/signatures/signature-designer/composables/useFontSizeScale'

const availableFields = [
  'displayName',
  'imageUrl',
  'telephoneNumber',
  'website',
  'facebook',
  'instagram',
  'youtube',
  'linkedin',
  'x',
  'chat',
  'font',
  'fontSize'
]

defineProps({
  data: { type: Object, required: true },
})

defineExpose({
  availableFields,
  imageSlots: [
    { field: 'imageUrl', aspect: 'banner' }
  ],
  previewTheme: { id: 'black', background: '#000000', text: 'black' }
})
</script>
